import StickyNoteIcon from '@listening/assets/icons/stickyNote.svg?react';
import * as m from '@/paraglide/messages';

function EmptyNotes() {
  return (
    <div className='flex flex-col items-center justify-center gap-3'>
      <StickyNoteIcon className='mx-auto size-8 text-primary' />
      <p className='text-center text-base leading-6 font-[600] tracking-[0.02rem] text-steel-920 dark:text-white'>
        {m.read_along_no_notes_available()}
      </p>
      <p className='p-2 text-center text-base leading-7 font-[500] text-steel-900 dark:text-steel-260'>
        {m.read_along_create_note_hint_prefix()}{' '}
        <span className='text-center text-base leading-7 font-[500] text-azure-455'>
          "{m.read_along_add_new_short()}"
        </span>
        {m.read_along_create_note_hint_suffix()
          ? ` ${m.read_along_create_note_hint_suffix()}`
          : null}
      </p>
    </div>
  );
}

export default EmptyNotes;
